import store from '../../../store/store';
import { BaseView } from './base-view';
import { SearchResultItem } from '../interfaces/search-result.interface';
import { connect } from 'pwa-helpers';
import { customElement, property } from 'lit/decorators.js';
import { html, nothing } from 'lit';
import { PageTypes } from '../../../common/utils/page-util';

@customElement('mhecomm-product-program-list-view')
export class ProductProgramListView extends connect(store)(BaseView) {

  @property({ type: Boolean })
  showProductWishList?: boolean;

  private viewName = 'product-program-list-view';
  

  renderComp() {
    return this.renderSearchResults(this.viewName);
  }

  /**
   * There is no list view for HE products, returning nothing.
   *
   * @param _searchResultItem
   */
  override renderHeProduct(_searchResultItem: SearchResultItem) {
    return nothing;
  }

  /**
   * Renders the list view element for a K12 product.
   *
   * @param searchResultItem
   */
  override renderK12Product(searchResultItem: SearchResultItem) {
    return html`
      <mhecomm-k12-product-list-display 
        .product=${searchResultItem.product}
        ?showProductWishList=${this.showProductWishList}
      >
      </mhecomm-k12-product-list-display>
      ${this.getSeparator(searchResultItem.isLast)}
    `;
  }

  /**
   * Renders the list view element for a K12 program.
   *
   * @param searchResultItem
   */
  override renderK12Program(searchResultItem: SearchResultItem) {
    return html`
      <mhecomm-k12-program-list-display .product=${searchResultItem.product}></mhecomm-k12-program-list-display>
      ${this.getSeparator(searchResultItem.isLast)}
    `;
  }

  /**
   * Returns a separator, it is hidden if it is the last element.
   *
   * @param isLast
   * @private
   */
  private getSeparator(isLast?: boolean) {
    return isLast ? html`<div class="my-3"/>` : html`<hr class="my-3"/>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-product-program-list-view': ProductProgramListView;
  }
}
